export default __webpack_public_path__ + "static/media/514.ee39b559.png";